import { z } from "zod";
import { SHIPMENT_STATUSES } from "@cx/domain";

/** Volta do OAuth do Melhor Envio: `code` e `state`; `error` quando o usuário recusa. */
export const melhorEnvioCallbackSearch = z.object({
  code: z.string().max(4096).optional().catch(undefined),
  state: z.string().max(64).optional().catch(undefined),
  error: z.string().max(100).optional().catch(undefined),
});

/** Consentimento do Melhor Envio de testes. */
export const melhorEnvioSandboxSearch = z.object({ state: z.string().max(64).optional().catch(undefined) });

/** Objetos de postagem: filtro de situação (sem filtro = todos). */
export const shipmentsSearch = z.object({
  situacao: z.enum(SHIPMENT_STATUSES).optional().catch(undefined),
});
